import React, { useState, useEffect } from 'react';
import PlayFeedVideoCard from './PlayFeedVideoCard';

interface GridProps {
  videos: any[];
  activeCategory: string;
  onSelectVideo: (video: any) => void;
  loading?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
}

export default function PlayFeedGrid({ videos, activeCategory, onSelectVideo, loading, hasMore, onLoadMore }: GridProps) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Lógica de filtragem por categoria (se for 'Tudo', mostra todos)
  const filteredVideos = activeCategory === 'Tudo' || !activeCategory
    ? videos
    : videos.filter(v => (v.category || '').toLowerCase().includes(activeCategory.toLowerCase()));

  return (
    <div className="custom-scrollbar" style={{
      flex: 1,
      padding: isMobile ? '16px' : '30px',
      backgroundColor: '#000',
      height: '100%', 
      maxHeight: 'calc(100vh - 80px)', 
      overflowY: 'auto', 
      boxSizing: 'border-box'
    }}>
      
      <style>
        {`
          /* Estilo padrão elegante para PC */
          .custom-scrollbar::-webkit-scrollbar {
            width: 8px; 
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #000; 
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #333; 
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #E50914; 
          }

          /* 👇 AJUSTE 2: Esconde a barra visualmente no telemóvel, mas mantém o toque/scroll funcionando */
          @media (max-width: 768px) {
            .custom-scrollbar::-webkit-scrollbar {
              display: none; /* Chrome, Safari, Opera */
            }
            .custom-scrollbar {
              -ms-overflow-style: none;  /* IE e Edge */
              scrollbar-width: none;  /* Firefox */
            }
          }
        `}
      </style>

      {/* Título da Seção Dinâmico */}
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ color: '#fff', fontSize: isMobile ? '18px' : '22px', fontWeight: 'bold', margin: 0, textTransform: 'capitalize' }}>
          {activeCategory === 'Tudo' ? 'Explorar PlayFeed' : `Categoria: ${activeCategory}`}
        </h2>
        <span style={{ color: '#666', fontSize: '13px' }}>
          {filteredVideos.length} vídeos carregados
        </span>
      </div>

      {/* Grade Responsiva Automática */}
      {filteredVideos.length > 0 ? (
        <>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '20px',
            width: '100%'
          }}>
            {filteredVideos.map((video) => (
              <PlayFeedVideoCard 
                key={video.id || video._id} 
                video={video} 
                onSelectVideo={onSelectVideo} 
              />
            ))}
          </div>
{/* Área do Botão "Carregar Mais" ou "Carregando" (Com respiro generoso para mobile) */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px', paddingBottom: '100px', width: '100%' }}>
          {loading ? (
            <div style={{ color: '#E50914', fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px', padding: '12px' }}>
              <div style={{ width: '16px', height: '16px', border: '3px solid #E50914', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
              A carregar vídeos...
              <style>
                {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
              </style>
            </div>
          ) : hasMore ? (
            <button
              onClick={onLoadMore}
              style={{
                backgroundColor: 'rgba(229, 9, 20, 0.2)',
                border: '1px solid rgba(229, 9, 20, 0.6)',
                color: '#fff',
                padding: '14px 28px',
                borderRadius: '12px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
                boxShadow: '0 4px 20px rgba(229,9,20,0.25)',
                transition: 'all 0.2s',
                width: '90%',
                maxWidth: '280px',
                textAlign: 'center',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#E50914';
                e.currentTarget.style.boxShadow = '0 6px 25px rgba(229,9,20,0.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(229, 9, 20, 0.2)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(229,9,20,0.25)';
              }}
            >
              Carregar Mais Vídeos
            </button>
          ) : (
            <span style={{ color: '#888', fontSize: '13px', textAlign: 'center', padding: '10px' }}>Você chegou ao fim da lista.</span>
          )}
        </div>
        </>
      ) : loading ? (
        // Estado de loading inicial (quando ainda não há vídeos)
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', color: '#E50914', fontWeight: 'bold', fontSize: '18px' }}>
          <div style={{ width: '30px', height: '30px', border: '4px solid #E50914', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', marginRight: '10px' }} />
          A carregar...
        </div>
      ) : (
        // Estado Vazio real
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
          <p style={{ fontSize: '16px', margin: '0 0 8px 0' }}>Nenhum vídeo encontrado nesta categoria.</p>
          <p style={{ fontSize: '13px', margin: 0 }}>Tente selecionar "Início" ou publicar novos conteúdos no painel.</p>
        </div>
      )}

    </div>
  );
}